var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container popular-destination"},[_c('top-flotilla',{staticClass:"popular-flot section-item"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }